/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Error_GenericInputs */

const en_contact_error_generic = /** @type {(inputs: Contact_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We could not send your message. Please try again in a moment.`)
};

/**
* | output |
* | --- |
* | "We could not send your message. Please try again in a moment." |
*
* @param {Contact_Error_GenericInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const contact_error_generic = /** @type {((inputs?: Contact_Error_GenericInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Error_GenericInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_contact_error_generic(inputs)
});